import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const {
  schedulerUpdateBegin,
  schedulerUpdateSuccess,
  schedulerUpdateErr,

  templateListBegin,
  templateListSuccess,
  templateListErr,

  hostListingListBegin,
  hostListingListSuccess,
  hostListingListErr,

  additionalMessageListingListBegin,
  additionalMessageListingListSuccess,
  additionalMessageListingListErr,

  channelListBegin,
  channelListSuccess,
  channelListErr,

  updateChannelMessageBegin,
  updateChannelMessageSuccess,
  updateChannelMessageErr,

} = actions;

const GetEmailTemplates = '/admin/get-email-template';

const schedulerUpdateAPIName = '/admin/update-scheduler-details';

const getHostListingAPI = '/admin/get-host-listings';
const updateListingAdditionalMessageAPI = '/admin/update-listing-additional-message';

const getChannelMessageAPI = '/admin/get-channel-message';
const updateChannelMessageAPI = '/admin/update-channel-message';


const updateScheduler = (values) => {
  return async (dispatch) => {
    dispatch(schedulerUpdateBegin());
    try {
      const response = await DataService.post(schedulerUpdateAPIName, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(schedulerUpdateErr(response?.data?.message));
      } else {
        dispatch(schedulerUpdateSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(schedulerUpdateErr(err));
    }
  };
};

const fetchEmailTemplates = (values) => {
  return async (dispatch) => {
    dispatch(templateListBegin());
    try {
      const response = await DataService.post(GetEmailTemplates, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(templateListErr(response?.data?.message));
      } else {
        dispatch(templateListSuccess, response?.data);
      }
      return response?.data;
    } catch (err) {
      dispatch(templateListErr(err));
    }
  };
};


const fetchHostListing = (values) => {
  return async (dispatch) => {
    dispatch(hostListingListBegin());
    try {
      const response = await DataService.post(getHostListingAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(hostListingListErr(response?.data?.message));
      } else {
        dispatch(hostListingListSuccess, response?.data);
      }
      return response?.data;
    } catch (err) {
      dispatch(hostListingListErr(err));
    }
  };
};


const updateListingAdditionalMessage = (values) => {
  return async (dispatch) => {
    dispatch(additionalMessageListingListBegin());
    try {
      const response = await DataService.post(updateListingAdditionalMessageAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(additionalMessageListingListErr(response?.data?.message));
      } else {
        dispatch(additionalMessageListingListSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(additionalMessageListingListErr(err));
    }
  };
};

const fetchChannel = (values) => {
  return async (dispatch) => {
    dispatch(channelListBegin());
    try {
      const response = await DataService.post(getChannelMessageAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(channelListErr(response?.data?.message));
      } else {
        dispatch(channelListSuccess, response?.data);
      }
      return response?.data;
    } catch (err) {
      dispatch(channelListErr(err));
    }
  };
};


const updateChannelMessage = (values) => {
  return async (dispatch) => {
    dispatch(updateChannelMessageBegin());
    try {
      const response = await DataService.post(updateChannelMessageAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(updateChannelMessageErr(response?.data?.message));
      } else {
        dispatch(updateChannelMessageSuccess(response?.data));
      }
      return response?.data;
    } catch (err) {
      dispatch(updateChannelMessageErr(err));
    }
  };
};

export {updateScheduler, fetchEmailTemplates, fetchHostListing, updateListingAdditionalMessage, fetchChannel, updateChannelMessage};
